module.exports = __webpack_public_path__ + "img/about-2.cfff4994.png";